import {
  TextNode,
  SerializedTextNode,
  LexicalNode,
  NodeKey,
  $applyNodeReplacement,
  EditorConfig,
  DOMConversionMap,
  Spread,
} from 'lexical';

export type SerializedWhatsAppItalicNode = Spread<
  {
    type: 'whatsapp-italic';
  },
  SerializedTextNode
>;

/**
 * WhatsApp Italic Node
 * Uses underscore (_text_) for italic formatting
 */
export class WhatsAppItalicNode extends TextNode {
  static getType(): string {
    return 'whatsapp-italic';
  }

  static clone(node: WhatsAppItalicNode): WhatsAppItalicNode {
    return new WhatsAppItalicNode(node.__text, node.__key);
  }



  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(text: string, key?: NodeKey) {
    super(text, key);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const element = document.createElement('em');
    element.className = config.theme.whatsappItalic || '';
    element.textContent = this.__text;
    return element;
  }


  updateDOM(prevNode: WhatsAppItalicNode, dom: HTMLElement): boolean {
    // If the text content has changed, update the DOM
    const prevText = prevNode.__text;
    const currentText = this.__text;
    
    if (prevText !== currentText) {
      dom.textContent = currentText;
    }
    
    // Return false because we handle the update ourselves
    return false;
  }

  static importDOM(): DOMConversionMap | null {
    return {
      em: () => ({
        conversion: () => ({ node: null }),
        priority: 1,
      }),
      i: () => ({
        conversion: () => ({ node: null }),
        priority: 1,
      }),
    };
  }

  static importJSON(serializedNode: SerializedWhatsAppItalicNode): WhatsAppItalicNode {
    const node = $createWhatsAppItalicNode(serializedNode.text);
    node.setFormat(serializedNode.format);
    node.setDetail(serializedNode.detail);
    node.setMode(serializedNode.mode);
    node.setStyle(serializedNode.style);
    return node;
  }

  exportJSON(): SerializedWhatsAppItalicNode {
    return {
      ...super.exportJSON(),
      type: 'whatsapp-italic',
    };
  }

  exportMarkdown(): string {
    return `_${this.__text}_`;
  }
}

export function $createWhatsAppItalicNode(text: string): WhatsAppItalicNode {
  return $applyNodeReplacement(new WhatsAppItalicNode(text));
}

export function $isWhatsAppItalicNode(
  node: LexicalNode | null | undefined
): node is WhatsAppItalicNode {
  return node instanceof WhatsAppItalicNode;
}
